export const getCountries = async (params = {}) => {
  const key = `countries-${JSON.stringify(params)}`;
  return useFetchSafely(() => `countries`, {
    key,
    params,
  });
};

export const useShippingMethods = async (country, token) => {
  return useFetchSafely(() => "shipping-methods", {
    key: `shipping-methods-${country}`,
    method: "POST",
    body: {
      token,
      country,
    },
  });
};

export const useCreateOrder = async (data) => {
  safeRemoveStoredItem("createOrder");
  return useFetchSafely(() => `order/store`, {
    method: "POST",
    body: data,
    key: `createOrder-${Date.now()}`,
  });
};

export const useAgreeToGovernmentResults = async (orderToken, body) =>
  useFetchSafely(() => `order/update-terms/${orderToken}`, {
    method: "POST",
    body,
  });

export const usePaymentOptions = async (orderToken) => {
  return useFetchSafely(() => `/payment/${orderToken}`);
};

/**
 *
 * @param {number | string} clinic_id - Clinic Id
 * @param {number} test_id - Test Id
 * @param {UseFetchSafelyOptions} options - custom fetch options and overrides.
 * @returns
 */

export const useCartDetails = async (data, options = {}) => {
  return await useFetchSafely(() => `order/cart`, {
    params: data,
  });
};

export const useOrderDetails = async (token, bypass = false) => {
  const { value: orderCookie } = useCookie("orderDetailsCookie");

  const checkoutStore = useCheckoutStore();
  const isDirectPayment = checkoutStore.paymentType === "direct_payment";

  return useFetchSafely(() => `order/show/${token}`, {
    onRequest({ options }) {
      if (!isDirectPayment || orderCookie || bypass) return;

      /**
       * Add required data security headers.
       */
      options.headers = {
        "direct-payment": "only-appointment-details",
      };
    },
  });
};

export const useUpdateOrder = async (token, payload) => {
  return useFetchSafely(() => `/order/update/${token}`, {
    body: payload,
    method: "POST",
  });
};

export const useDirectPayment = async (token) => {
  return useFetchSafely(() => `direct-payment/${token}`);
};

export const useManualPayment = async (token) => {
  return useFetchSafely(() => `manual-payment/${token}`);
};

export const useManualPaymentIntent = async (token) => {
  return useFetchSafely(() => `manual-payment/intent/${token}`, {
    method: "POST",
    key: `manualPaymentIntent-${token}`,
  });
};

export const useUpdateManualPayment = async (token, payload) => {
  return useFetchSafely(() => `manual-payment/update/${token}`, {
    method: "POST",
    body: payload,
    key: `manualPaymentUpdate-${Date.now()}`,
  });
};

export const useSendEmail = async (token) => {
  return useFetchSafely(() => `order/send-email/${token}`);
};

export const useSendClientReview = async (orderToken, rating, comment) => {
  return useFetchSafely(() => `/customer-feedback/${orderToken}`, {
    body: { rating, comment },
    method: "POST",
  });
};

export const useDayjsLocale = async () => {
  try {
    const locale = useGlobalStore().siteCurrentLocale;
    const language = {
      en: () => import("dayjs/locale/en"),
      "pl-pl": () => import("dayjs/locale/pl"),
      "hu-hu": () => import("dayjs/locale/hu"),
      "en-gb": () => import("dayjs/locale/en-gb"),
      "en-au": () => import("dayjs/locale/en-au"),
    };
    if (language[locale]) {
      await language[locale]();
    }
  } catch (error) {
    console.error(`Failed to load locale :`, error);
  }
};
